import Autocomplete from 'components/autocomplete/Autocomplete';
import _ from 'underscore';
import jQuery from 'jquery';
import { DESTINATIONS_TREE } from '../../globals/widgetTypes';

export default Autocomplete.extend({
    componentClass: 'autocomplete',
    template: require('./autocomplete.hbs'),

    initialize(config) {
        this.providers = [];
        Autocomplete.prototype.initialize.call(this, config);
        this._showSearchIcon();
        if (this.widget.typeWidget === DESTINATIONS_TREE){
            this.listenTo(this.widget.bus, 'RELOAD_LIST', hotelUid => {
                this.widget.hotelMeliaList = hotelUid;
            });
            this.listenTo(this.widget.bus, 'REGION_CHANGED', destination => {
                this.widget.hotelMeliaList = [];
                this.widget.config.initialDestinationId = destination.regionId;
                this.providers[1].load(this.widget);
            });
        }
    },

    _initAutoComplete() {
        this.input[this.autocompleteType]({
            minLength: this._getMinKeystroke(),
            source: (request, response) => {
                this._lookup(request, response);
            },
            appendTo: this.resultsPanel,
            autoFocus: this.autoFocus,
            select: (event, ui) => {
                this._onSelect(ui.item);
            },
            open: () => {
                if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                    jQuery('.ui-autocomplete').off('menufocus hover mouseover');
                }
                this.bus.trigger('SHOW_RESULTS_LIST');
                this.onOpen();
            },
            close: () => {
                this.onClose();
            }
        });
        this._calculateMaxHeightAutocomplete();
    },

    _onSelect(item) {
        this._reloadAutocompleteInput();
        if (item.provider === 'ListCategoriesProvider') {
            this.bus.trigger('AUTOCOMPLETE_CATEGORY_SELECTED', item, this);
        } else if (item.provider === 'ListHotelsProvider') {
            this.providerListHotel(item);
        } else {
            this._handleCoordinates(item);
        }
    },

    providerListHotel(item) {
        let location = new google.maps.LatLng(item.coords.lat, item.coords.lon);
        if (this.widget.typeWidget === DESTINATIONS_TREE) {
            if (!this.widget.isMobileVersion){
                this.widget.getMainHotelData(item.code).then((item) => {
                    this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA',item);
                    this._displaceMap(location, item);
                });
            } else {
                this.widget.getMainHotelData(item.code).then((item) => {
                    if (item.hotel) {
                        item = item.hotel;
                    }
                    item.id = item.code;
                    item.layerId = 'destinationTreeLayer';
                    this.widget.bus.trigger('CLICK_ON_MARKER', item);
                    this._displaceMap(location, item);
                });
            }
        } else {
            this._displaceMap(location, item);
        }
    },

    _handleCoordinates(item) {
        item.coordinates().done(coords => {
            let location = null;
            if (coords instanceof google.maps.LatLng) {
                location = coords;
            } else if (!_.isUndefined(coords.viewport)) {
                location = coords.location;
            }
            this._displaceMap(location, item);
        });
    },

    _displaceMap(location, item){
        this.bus.trigger('SELECT_RESULT');
        if (this._canMoveMap(location)) {
            this._goToLocation(location);
            this._createPReference(location, item);
            this._showResetIcon();
            this.input.blur();
            this.input.trigger('blur');
            this.widget.trackUserAction({
                tracking: 'Autocomplete',
                selected: item.value
            });
            this.bus.trigger('AUTOCOMPLETE_RESULT_SELECTED', item, this);
        } else {
            this._resetAutocomplete();
            this.widget.messageControl.createMessage(
                'error',
                this.widget.polyglot.t('panelTT.outsideBounds'),
                false,
                false
            );
        }
    },

    _checkInputEmpty() {
        if (!this.input.val()) {
            this._hideResetIcon();
            this._showSearchIcon();
            this.errorPanel.hide();
            this._userActionReset();
        } else {
            this._showResetIcon();
            this._hideSearchIcon();
        }
    },

    _hideSearchIcon() {
        this.$el.find('.search').hide();
    },

    _showSearchIcon() {
        this.$el.find('.search').show();
    },

    _resetAutocomplete() {
        this._showSearchIcon();
        Autocomplete.prototype._resetAutocomplete.call(this);
    },

    fillAutocomplete(text) {
        this.input.val(text);
        this._showResetIcon();
        this._hideSearchIcon();
    },

    _lookup(request, response) {
        let promises = [];
        let _this = this;
        this.promisesFinished = 0;

        this.widget.trackUserAction({
            tracking: 'Autocomplete',
            text: request.term
        });

        this.providers.forEach(provider => {
            provider.requestIsFinished = false;

            if (provider.validate(request.term)) {
                promises.push(provider.getPredictions(request.term));
            }
        });

        jQuery.when.apply(jQuery, promises).then(
            function() {
                let totalResults = [],
                    args = arguments || [],
                    hasResults = false;

                function filterResults(results, totalResults) {
                    totalResults.push.apply(
                        totalResults,
                        results.filter(result => {
                            return !_.isUndefined(result.code);
                        })
                    );
                }

                for (let i = 0; i < args.length; i++) {
                    let results = args[i];
                    filterResults(results, totalResults);
                }

                if (totalResults.length > 0) {
                    if (totalResults.length === 1 && _.isEmpty(totalResults[0])) {
                        hasResults = false;
                    } else {
                        hasResults = true;
                        totalResults.reverse();
                    }
                } else {
                    hasResults = false;
                }

                if (!hasResults) {
                    _this.errorPanel.show();
                } else {
                    _this.errorPanel.hide();
                }

                response(totalResults);
            },
            function() {
                response([]);
            }
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/autocomplete/Autocomplete.js